export function stripInformation(posts) {
	return posts.map(function (post) {
		return {
			id: post.ID,
			title: post.post_title,
			content: post.post_content,
			source: post.customs.mkdf_post_link_link_meta ? post.customs.mkdf_post_link_link_meta[0] : null,
			source_name: post.customs.article_source[0],
			date: post.formatted_date,
			youtube_id: post.customs.youtube_id ? post.customs.youtube_id[0] : null,
			link: post.link,
			thumbnail: {
				url: post.post_thumbnail_url,
				alt: post.post_thumbnail_alt,
				width: post.post_thumbnail_width,
				height: post.post_thumbnail_height,
			},
			categories: post.categories
		};
	});
}


// WEBPACK FOOTER //
// ./src/shared/stripInformation.js